/* =====================================================
   assets/find-device-fit-2026.js
   NuFace 2026 Redesign — Find Your Device Fit slider
   MS 2026-05-18

   Desktop  : fade in-place (CSS opacity via is-active)
   Mobile   : native scroll-snap flex track + seamless clone loop
              (mirrors pdp-key-ingredients-2026.js). Manual only —
              native swipe + arrows; no autoplay.
   Loaded only when section has 2+ devices.
   ===================================================== */

(function () {
  'use strict';

  var MOBILE_BP = 1023; /* matches CSS ≤1023px block */

  function initSection(section) {
    var slidesRail = section.querySelector('[data-df-slides]');
    if (!slidesRail) return;

    var originals = Array.prototype.slice.call(
      slidesRail.querySelectorAll('[data-df-slide]')
    );
    var n = originals.length;
    if (n < 2) return;
    if (section.dataset.dfInited === '7') return;
    section.dataset.dfInited = '7';

    var beforeFrag = document.createDocumentFragment();
    var afterFrag = document.createDocumentFragment();
    originals.forEach(function (slide) {
      var after = slide.cloneNode(true);
      after.classList.add('is-clone');
      after.removeAttribute('data-df-slide');
      after.setAttribute('aria-hidden', 'true');
      afterFrag.appendChild(after);

      var before = slide.cloneNode(true);
      before.classList.add('is-clone');
      before.removeAttribute('data-df-slide');
      before.setAttribute('aria-hidden', 'true');
      beforeFrag.appendChild(before);
    });
    slidesRail.appendChild(afterFrag);
    slidesRail.insertBefore(beforeFrag, slidesRail.firstChild);

    var mql = window.matchMedia('(max-width: ' + MOBILE_BP + 'px)');
    var currentIndex = 0;
    for (var i = 0; i < n; i++) {
      if (originals[i].classList.contains('is-active')) {
        currentIndex = i;
        break;
      }
    }

    function allSlides() {
      return slidesRail.querySelectorAll('.device-fit-2026__slide');
    }

    function step() {
      var styles = getComputedStyle(slidesRail);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return originals[0].getBoundingClientRect().width + gap;
    }

    function snapOffset() {
      return parseFloat(getComputedStyle(slidesRail).scrollPaddingLeft) || 0;
    }

    function setWidth() {
      return n * step();
    }

    function originalIndexFromScrollIdx(idx) {
      if (idx >= n && idx < 2 * n) return idx - n;
      if (idx < n) return idx;
      return idx - 2 * n;
    }

    function centerOriginals() {
      if (!mql.matches) return;
      slidesRail.scrollLeft = setWidth() - snapOffset();
    }

    function normalize() {
      if (!mql.matches) return;
      var s = setWidth();
      var pad = snapOffset();
      if (slidesRail.scrollLeft >= 2 * s - pad - 1) slidesRail.scrollLeft -= s;
      else if (slidesRail.scrollLeft < s - pad - 1) slidesRail.scrollLeft += s;
    }

    function syncAria(origIdx) {
      currentIndex = origIdx;
      for (var i = 0; i < n; i++) {
        originals[i].setAttribute('aria-hidden', i === origIdx ? 'false' : 'true');
      }
    }

    function setActiveFromScroll() {
      if (!mql.matches) return;
      var list = allSlides();
      if (!list.length) return;
      var idx = Math.round((slidesRail.scrollLeft + snapOffset()) / step());
      idx = Math.max(0, Math.min(idx, list.length - 1));
      for (var i = 0; i < list.length; i++) {
        list[i].classList.toggle('is-active', i === idx);
      }
      syncAria(originalIndexFromScrollIdx(idx));
    }

    function goToSlideDesktop(index) {
      var nextIndex = (index + n) % n;
      if (nextIndex === currentIndex) return;
      originals[currentIndex].classList.remove('is-active');
      originals[currentIndex].setAttribute('aria-hidden', 'true');
      currentIndex = nextIndex;
      originals[currentIndex].classList.add('is-active');
      originals[currentIndex].setAttribute('aria-hidden', 'false');
    }

    function advance(dir) {
      slidesRail.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }

    function next() {
      if (mql.matches) advance(1);
      else goToSlideDesktop(currentIndex + 1);
    }

    function prev() {
      if (mql.matches) advance(-1);
      else goToSlideDesktop(currentIndex - 1);
    }

    var prevBtns = section.querySelectorAll('[data-df-prev]');
    var nextBtns = section.querySelectorAll('[data-df-next]');

    function bindTrigger(el, fn) {
      el.addEventListener('click', fn);
      if (el.tagName !== 'BUTTON') {
        el.addEventListener('keydown', function (e) {
          if (e.repeat) return;
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            fn();
          }
        });
      }
    }
    prevBtns.forEach(function (btn) { bindTrigger(btn, prev); });
    nextBtns.forEach(function (btn) { bindTrigger(btn, next); });

    section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')       prev();
      else if (e.key === 'ArrowRight') next();
    });

    var raf, settle;
    slidesRail.addEventListener('scroll', function () {
      if (!mql.matches) return;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(setActiveFromScroll);
      clearTimeout(settle);
      settle = setTimeout(normalize, 90);
    }, { passive: true });

    function resetDesktop() {
      slidesRail.scrollLeft = 0;
      var list = allSlides();
      for (var i = 0; i < list.length; i++) {
        var active = !list[i].classList.contains('is-clone') &&
          originals.indexOf(list[i]) === currentIndex;
        list[i].classList.toggle('is-active', active);
      }
      syncAria(currentIndex);
    }

    function onMQ() {
      if (mql.matches) {
        centerOriginals();
        setActiveFromScroll();
      } else {
        resetDesktop();
      }
    }

    if (mql.addEventListener) mql.addEventListener('change', onMQ);
    else if (mql.addListener) mql.addListener(onMQ);

    window.addEventListener('resize', function () {
      if (mql.matches) {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(setActiveFromScroll);
      }
    });

    requestAnimationFrame(function () {
      if (mql.matches) {
        centerOriginals();
        setActiveFromScroll();
      }
    });
    window.addEventListener('load', function () {
      if (mql.matches) {
        centerOriginals();
        setActiveFromScroll();
      }
    });
  }

  function initAll(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('.device-fit-2026[data-slides-count]');
    for (var i = 0; i < sections.length; i++) {
      var count = parseInt(sections[i].dataset.slidesCount, 10) || 0;
      if (count > 1) initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
